module.exports = __webpack_public_path__ + "img/factory_plate_PVC.15e4df4a.jpg";